export default __webpack_public_path__ + "static/media/BPS-Banner_Dashboard_full.16626fce.png";